import { Toast } from "@base-ui/react/toast";
import { CheckCircleIcon, InfoIcon, WarningCircleIcon, XIcon } from "@phosphor-icons/react";
import { useEffect, type ReactNode } from "react";
import { subscribeFeedback } from "../feedback.ts";
import { KIT_LABELS } from "../labels.ts";

/** One viewport outside the router keeps action results visible after navigation. */
export function FeedbackProvider({ children }: { children: ReactNode }) {
  return <Toast.Provider limit={3}>{children}<FeedbackViewport /></Toast.Provider>;
}

function FeedbackViewport() {
  const { toasts, add, close } = Toast.useToastManager();
  useEffect(() => subscribeFeedback(({ tone, message }) => {
    add({ id: `${tone}:${message}`, title: message, type: tone, timeout: tone === "error" ? 0 : 4000, priority: tone === "error" ? "high" : "low" });
  }), [add]);
  // Base UI marks overflow items as limited; close them so persistent errors
  // cannot accumulate invisibly behind the three visible messages.
  useEffect(() => { for (const toast of toasts) if (toast.limited && toast.transitionStatus !== "ending") close(toast.id); }, [toasts, close]);
  return <Toast.Portal><Toast.Viewport className="z-toast-viewport" aria-label={KIT_LABELS.notifications}>
    {toasts.map((toast) => <Toast.Root key={toast.id} toast={toast} className="z-toast" swipeDirection="right">
      <span className="z-toast-icon" aria-hidden>{toast.type === "error" ? <WarningCircleIcon size={18} /> : toast.type === "success" ? <CheckCircleIcon size={18} /> : <InfoIcon size={18} />}</span>
      <Toast.Title className="z-toast-title" />
      <Toast.Close className="z-toast-close" aria-label={KIT_LABELS.close}><XIcon size={16} aria-hidden /></Toast.Close>
    </Toast.Root>)}
  </Toast.Viewport></Toast.Portal>;
}
